export default __webpack_public_path__ + "static/media/circle-small.633474f4.svg";